// Urls Sitio

export let UsersUrl = 'https://sitio-bd.herokuapp.com/administracion/users/'
export let LoginUrl = 'https://sitio-bd.herokuapp.com/login/'
export let ChangePasswordUrl = 'https://sitio-bd.herokuapp.com/cambiarPassword/'
export let SolicitarPasswordUrl = 'https://sitio-bd.herokuapp.com/solicitarRecuperacionPassword/'
export let RecuperarPasswordUrl = 'https://sitio-bd.herokuapp.com/recuperarPassword/'

export let ItemsUrl = 'https://backoffice-bd.herokuapp.com/administracion/productos/'
export let ServiciosUrl = 'https://backoffice-bd.herokuapp.com/administracion/servicios/'
export let PagosUrl = 'https://backoffice-bd.herokuapp.com/administracion/metodoPago/'
export let HistorialPagoUrl = 'https://backoffice-bd.herokuapp.com/administracion/historialPago/'
export let HistorialPagoPorUsuarioUrl = 'https://backoffice-bd.herokuapp.com/historialPagoPorUsuario/'

// DEV - 127.0.0.1
// PROD - haddy.eastus2.cloudapp.azure.com
